import React, { Component } from 'react';
import Index from '../components/formatos/ModuleTransfers/Index'
import WebpackerReact from 'webpacker-react';

class ModuleTransferIndex extends Component {
    constructor(props) {
        super(props);
        this.token = document.querySelector("[name='csrf-token']").content;
        this.state = {
            history: [],
            isLoaded: true,
        }
    }

    componentDidMount(){
        this.loadHistory();
    }

    updateStateLoad = (state) => {
        this.setState({ isLoaded: state })
    }

    loadHistory = () => {
        fetch(`/formatos/module_transfers/history`, {
            method: 'GET',
            headers: {
                "X-CSRF-Token": this.token,
                "Content-Type": "application/json"
            }
        })
        .then(response => response.json())
        .then(data => {
          this.setState({
            history: data.history || [],
            isLoaded: false
          });
        });
    }

    render() {
        return (
            <React.Fragment>
                <Index
                    updateStateLoad={this.updateStateLoad}
                    loadHistory={this.loadHistory}
                    history={this.state.history}
                    isLoaded={this.state.isLoaded}
                />
            </React.Fragment>
        );
    }
}

export default ModuleTransferIndex;
WebpackerReact.setup({ ModuleTransferIndex });
